"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decodePath = decodePath;
exports.encodePath = encodePath;
exports.startsWith = startsWith;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * A path suitable for use as a key in a Map.
 *
 * Right now just serialized to string, but this is hidden from users of this
 * module with an opaque type.
 *
 * 
 */
function startsWith(path, prefix) {
  return path.startsWith(prefix);
}

function encodePath(path) {
  return "/" + path.map(function (p) {
    if (p.type === "object") {
      return "o>".concat(p.key);
    } else if (p.type === "array") {
      return "a>".concat(p.index);
    } else {
      p.type; // eslint-disable-line no-unused-expressions

      throw new Error("Bad path type ".concat(p.type));
    }
  }).join("/");
}

function decodePath(s) {
  return s.split("/").filter(function (x) {
    return x !== "";
  }).map(function (s) {
    var _s$split = s.split(">"),
        _s$split2 = _slicedToArray(_s$split, 2),
        type = _s$split2[0],
        val = _s$split2[1];

    if (type === "o") {
      return {
        type: "object",
        key: val
      };
    } else if (type === "a") {
      return {
        type: "array",
        index: parseInt(val, 10)
      };
    } else {
      throw new Error("Bad encoded path type '".concat(type, "' for path '").concat(s, "'"));
    }
  });
}